// extracted by mini-css-extract-plugin
export default {"virtutu":"AccountPayableAgeExpandList_virtutu__9swYj"};